import { useCallback, useContext, useState } from "react";
import { LoginContext } from "../contexts/login_context";
import { ConsultaSimilaridade } from "../services/ConsultaSimilaridade";
import { dismissToast, showError, showWait } from "../services/toast";
import { useSearchPagination } from "../contexts/Ncm&Gpc_context";

export type SimilaridadeSearchParams = {
  code?: string | number | null;
  hasConteudoLiquido?: boolean;
  hasMarca?: boolean;
  pagina?: number;
  onAfterSearch?: (result: any) => void;
  onRequireConfirmation?: (data: { filtros: any; raw: any }) => void;
};

export function useSimilaridadeSearch() {
  const { jwt } = useContext(LoginContext);
  const {
    setDatapagina,
    setStepMaganer,
    setSelectedDatasetPage,
  } = useSearchPagination();
  const [loading, setLoading] = useState(false);

  const search = useCallback(
    async ({
      code,
      hasConteudoLiquido,
      hasMarca,
      pagina,
      onAfterSearch,
      onRequireConfirmation,
    }: SimilaridadeSearchParams) => {
      if (code === undefined || code === null) return;

      const toastId = showWait("Aguarde, enquanto realizamos sua pesquisa");
      setLoading(true);

      try {
        const r = await ConsultaSimilaridade(
          jwt, 
          String(code), 
          !!hasConteudoLiquido, 
          !!hasMarca, 
          pagina as number
        );

        if (r?.result?.requerConfirmacao) {
          onRequireConfirmation?.({ filtros: { code, hasConteudoLiquido, hasMarca, pagina }, raw: r.result });
          setDatapagina([]);
          setStepMaganer("list");
          setSelectedDatasetPage(0);
          return;
        }

        if (r?.success && r?.result) {
          const rawData = r.result?.data || r.result;
          const produtos = Array.isArray(rawData) ? rawData : [rawData];

          if (!produtos || produtos.length === 0) {
            setDatapagina([]);
            setStepMaganer("list");
            onAfterSearch?.({ raw: r.result, produtos: [] });
            showError("Nenhum resultado encontrado");
            setSelectedDatasetPage(0);
            return;
          }

          setDatapagina(produtos);
          setStepMaganer("table");
          onAfterSearch?.({ raw: r.result, produtos });
          setSelectedDatasetPage(0);
        } else {
          showError("Nada encontrado");
        }
      } catch (error) {
        showError("Erro na consulta");
      } finally {
        dismissToast(toastId);
        setLoading(false);
      }
    },
    [jwt, setDatapagina, setStepMaganer, setSelectedDatasetPage]
  );

  return { loading, search };
}